import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'settings' ]

  toggleSettings(event) {
    this.settingsTarget.classList.toggle('hidden', !event.target.checked);
  }
}
